import { OrganizationSharedFileEntity } from "@/src/hooks/api/generated";

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export function isRecentlyUpdated(dateString?: string | Date): boolean {
  if (!dateString) {
    return false;
  }
  const updatedDate = new Date(dateString);
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
  return updatedDate > twoWeeksAgo;
}

export function hasRecentUpdate(node: OrganizationSharedFileEntity): boolean {
  if (node.file_name && !node.files?.length) {
    if (isRecentlyUpdated(node.updatedAt || node.createdAt)) {
      return true;
    }
  }

  if (node.files && node.files.length > 0) {
    for (const child of node.files) {
      if (hasRecentUpdate(child)) {
        return true;
      }
    }
  }

  return false;
}

export function findResourcePath(
  nodes: OrganizationSharedFileEntity[],
  target: string | number,
  currentPath: OrganizationSharedFileEntity[] = []
): OrganizationSharedFileEntity[] | null {
  for (const node of nodes) {
    const newPath = [...currentPath, node];
    const isMatch =
      typeof target === "number"
        ? node.id === target
        : slugify(node.file_name) === target;

    if (isMatch) {
      return newPath;
    }
    if (node.files && node.files.length > 0) {
      const result = findResourcePath(node.files, target, newPath);
      if (result) {
        return result;
      }
    }
  }
  return null;
}
